<template>
    <div class="currency-container">
        <div class="currency-header">
            <span class="currency-add">Currencies</span>
            <v-tooltip bottom>
                <v-btn flat color="black" slot="activator" @click="addCurrencyItem" class="item-add-button-icon">
                    <v-icon large color="indigo">mdi-plus</v-icon>
                </v-btn>
                <div>Add new currency</div>
            </v-tooltip>
        </div>
        <div>
            <AppTable :data="currenciesData" :owner="'currency'" :saving="saving" @deleteItem="deleteCurrencyItem" @saveItem="saveCurrency" @cancelEdit="cancelEditCurrencyItem"
                @editItem="editCurrencyItem" class="currency-table" />
        </div>
     </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';

    import AppTable from '@/components/common/AppTable';

    export default {
        name: 'currency-settings',
        components: {
            AppTable
        },
        data() {
            return {
                saving: false
            };
        },
        computed: {
            ...mapGetters({ currencies: 'getCurrencies' }),
            currenciesData() {
                return {
                    items: [
                        ...this.currencies
                    ]
                };
            }
        },
        methods: {
            ...mapActions([
                'deleteCurrency',
                'addCurrency',
                'editCurrency',
                'cancelCurrencyEdit',
                'changeCurrency',
                'createNewCurrency'
            ]),
            deleteCurrencyItem(index) {
                this.deleteCurrency(index);
            },
            addCurrencyItem() {
                this.addCurrency({
                    id: -1,
                    name: '',
                    editting: true,
                    editable: true
                });
            },
            editCurrencyItem(currencyId) {
                this.editCurrency(currencyId);
            },
            cancelEditCurrencyItem() {
                this.cancelCurrencyEdit();
            },
            saveCurrency(payload) {
                this.saving = true;
                if (payload.id > 0) {
                    this.changeCurrency(payload).then(() => {
                        this.saving = false;
                    });
                } else {
                    this.createNewCurrency(payload.name).then(() => {
                        this.saving = false;
                    });
                }
            }
        }
    };
</script>
<style scoped>
.currency-container {
    padding-bottom: 26px;
}

.currency-header {
    font-size: 24px;
    padding-left: 24px;
    padding-bottom: 14px;
    margin-top: 10px;
}

.currency-table {
    margin: 0 26px;
}

.currency-add {
    margin-right: 15px;
}

@media screen and (max-width: 600px) {
    .currency-table {
        margin: 0 13px;
    }
    
    .card__text {
        padding-left: 8px;
        padding-right: 8px;
    }

    .currency-header {
        font-size: 14px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/CurrencySettings.vue